const mContentEditorBlockInputVideo = {
  mContentEditorBlockInputVideo: {
    inputs: {
      video: {
        placeholder: 'Pega aquí la url de Youtube, Vimeo, Amazon, Bunny o Canva.'
      }
    },

    validation: {
      video: {
        url: 'La url ingresada no es válida.'
      }
    }
  }
}

export default mContentEditorBlockInputVideo
